import { Route } from "react-router-dom";
import AuthorizedRoute from "../../components/routing/authorized-route";
import { Features, Roles } from "../../components/routing/utils";

import Clients from "./page.highorder";

function ProtectedManageClients() {
  const render = () => {
    return (
      <AuthorizedRoute
        requiredRoles={[Roles.NURSEADMIN]}
        component={Clients}
        requiredFeatures={[Features.MANAGE_RESIDENTS]}
      />
    );
  };

  return render();
}

const clientsRoute = (
  <Route path="/manage-residents" element={<ProtectedManageClients />} />
);

export default clientsRoute;
